import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { InviteCode } from '@root/entities/referral'
import { DelugeId } from '@root/entities/user-short'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type { UserChangeInviterCreateData } from '@blade/trade-api-client'

export interface UserChangeInviterRequestPayload {
  inviteCode: InviteCode
}

export interface ChangeInviterData {
  delugeId: DelugeId
  username: string
  usedInviteCode: InviteCode
}
const fromDto = (dto: UserChangeInviterCreateData): ChangeInviterData => ({
  delugeId: DelugeId(dto.delugeId),
  username: dto.username,
  usedInviteCode: InviteCode(dto.usedReferralCode),
})

export const changeInviterRequestAction = action(
  async (ctx, req: UserChangeInviterRequestPayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userChangeInviterCreate, [req]),
    )
    return result.pipe(
      Result.map(fromDto),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'changeInviterRequestAction',
)
